import React from 'react';
import styled from 'styled-components';
import { Add20Regular } from '@fluentui/react-icons';

const ButtonWrapper = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  &:hover {
    background-color:rgb(255, 255, 255);
    border-radius: 4px;
    color: #0078d4;
  }

  svg {
    width: 20px;
    height: 20px;
    fill: #0078d4;
  }
`;

interface ButtonPlusProps {
  onClick: () => void;
  ariaLabel?: string;
}

export const ButtonPlus: React.FC<ButtonPlusProps> = ({
  onClick,
  ariaLabel = 'Добавить',
}) => {
  return (
    <ButtonWrapper onClick={onClick} aria-label={ariaLabel}>
      <Add20Regular />
    </ButtonWrapper>
  );
};